import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function DepositType() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-type',
    method: 'post',
    data: {}
  })
}

export function DepositPayment(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-payment',
    method: 'post',
    data: object
  })
}

export function depositRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-record',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function withdrawalRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-record',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function withdrawalWallet() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-wallet',
    method: 'post'
  })
}

export function commissionToMain(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/commission-to-main',
    method: 'post',
    data: object
  })
}

export function withdrawalCheck(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-check',
    method: 'post',
    data: object
  })
}

export function withdrawalPayment(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-payment-v2',
    method: 'post',
    data: object
  })
}

export function DepositSetting() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-setting',
    method: 'post',
    data: {}
  })
}
export function DepositTransactions(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-transactions',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}
export function checkDepositRate(payment_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-rate',
    method: 'post',
    data: { payment_id }
  })
}
export function checkDepositCryptoRate(payment_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-realtime-rate-from-third',
    method: 'post',
    data: { payment_provider_channel_id: payment_id }
  })
}

export function getCoinlist(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/get-coinlist',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function getDepositAddress(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/get-deposit-address',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function walletTransfer(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/wallet-transfer',
    method: 'post',
    data: object
  })
}

export function walletTransferRate(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/wallet-transfer-rate',
    method: 'post',
    data: object
  })
}
